import { api } from '../utils/axios';

export const login = async (data) => {
  try {
    const response = await api.post('auth/login', data);
    if (response) {
      return response.data?.data;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

export const logout = async () => {
  // Host uses stateless JWT, no backend logout needed currently.
  // We just return success so the frontend flow continues (clearing local storage & redirecting).
  return Promise.resolve({ success: true });
};
